import type { ReferenceField } from '@uncinc/react-drupal-core/types';

import type {
  TaxonomyFunction,
  TaxonomyLabel,
  TaxonomyLocation,
  TaxonomyTheme,
} from '../../types/uncinc_profile/taxonomy';
import type { TagItem } from '.';

export function taxonomyTagEntityMapper(
  taxonomies: ReferenceField<TaxonomyLabel | TaxonomyTheme | TaxonomyFunction | TaxonomyLocation>[],
): TagItem[] {
  const tagItems = taxonomies.map((taxonomy) => (
    {
      name: taxonomy.entity.name[0].value,
      type: taxonomy.entity.vid[0].target_id,
    }
  ));

  return tagItems;
}

export function taxonomyTagElasticMapper(
  taxonomies?: string[],
  type?: string,
): TagItem[] {
  const tagItems = taxonomies?.map((taxonomy) => (
    {
      name: taxonomy,
      type,
    }
  ));

  return tagItems || [];
}
